import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockCalloutFields } from './groq';

/** Shared registry entry. Lazy: not on the critical rendering path. */
export const calloutBlockConfig = {
  name: 'inner-block-callout',
  component: defineAsyncComponent(() => import('./CmsCalloutBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('./Callout.vue')),
  fields: blockCalloutFields,
} satisfies ModularBlockConfig;
